import { Copy } from 'almanac-ui/icons/16'
import { getContainerBeforePos, getContainerDepth } from 'common/Prose/utils/getContainerBeforePos'
import { InlineFormatDropdownMenuItem } from 'components/InlineFormatBar/components/InlineFormatDropdownMenuItem/InlineFormatDropdownMenuItem'
import { Selection, TextSelection } from 'prosemirror-state'
import { EditorView } from 'prosemirror-view'
import React from 'react'

export type DuplicateTextInlineFormatButtonProps = {
  view: EditorView
  callback?: () => void
}

export const DuplicateTextInlineFormatButton: React.FC<
  React.PropsWithChildren<DuplicateTextInlineFormatButtonProps>
> = ({ view, callback }) => {
  const duplicateText = () => {
    const { state, dispatch } = view
    callback?.()
    const containerFromPos = getContainerBeforePos(state.doc, state.selection.from)
    const containerToPos = getContainerBeforePos(state.doc, state.selection.to)
    const containerToAfterPos = state.doc.resolve(containerToPos.pos + (containerToPos.nodeAfter?.nodeSize || 0))

    const copySelection = new Selection(containerFromPos, containerToAfterPos).content().content
    const cursorPosition =
      containerToAfterPos.pos +
      copySelection.size -
      1 -
      (containerToPos.nodeAfter ? getContainerDepth(containerToPos.nodeAfter.type.name) : 0)

    const tr = state.tr
    tr.insert(containerToAfterPos.pos, copySelection)
    tr.setSelection(new TextSelection(tr.doc.resolve(cursorPosition)))

    dispatch(tr)
  }

  return (
    <InlineFormatDropdownMenuItem
      key="duplicate-text"
      onClick={duplicateText}
      active={false}
      icon={<Copy />}
      label="Duplicate text"
    />
  )
}
